import React from "react";
import styled from "styled-components";

const Navbar = ({ className }) => {
  return <div className={className}></div>;
};

export default styled(Navbar)`
  width: 100%;
  height: 60px;
  background-color: #fff;
  border: 1px solid #eee;
`;
